import getDestination from './get_destination.js';

export const isSelectedPlan = function () {
    return ajax_var?.selected_plan?.length > 0;
};

export const getSelectedPlan = function () {
    return ajax_var.selected_plan;
}

export const getSelectedPlanURL = function () {
    if (isSelectedPlan()) {
        switch (getDestination()) {
            case "Hortisketch":
                return ajax_var.hortisketch_domain;
            case "Community":
                return ajax_var.community_domain;
            default:
                return ajax_var.account_page_url;
        }
    }

    return false;
}
